import React from 'react'
import { Widget } from 'features/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { getLabel } from 'utils/widgetTypeUtil'

import TopicComparisonWidget from '../share/TopicComparison'
import RunSearchEffect from '../share/RunSearchEffect'
import {
  TopicInfosEmptyGuard,
  WidgetLoadingGuard,
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard
} from '../../share/guards'
import { TopicComparisonWidgetType } from '../types'
import InsightModal from '../share/InsightModal'
import useSelectedInsights from '../share/InsightModal/hooks/useSelectedInsights'

const SocialWebTopicComparisonWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<TopicComparisonWidgetType>(widgetId)
  const {
    isModalOpen,
    selectedInsights,
    onClick,
    onClose,
    detailSetting,
    widgetSettingWithSelection
  } = useSelectedInsights(widgetSetting)
  return (
    <UnexpectedErrorBoundary>
      <TopicInfosEmptyGuard widgetId={widgetId}>
        <RunSearchEffect widgetId={widgetId}>
          <WidgetLoadingGuard widgetId={widgetId}>
            <TopicInaccessibleGuard widgetId={widgetId}>
              <TopicIndexNotReadyGuard widgetId={widgetId}>
                <TopicComparisonWidget widgetId={widgetId} onRowClick={onClick} />
              </TopicIndexNotReadyGuard>
            </TopicInaccessibleGuard>
          </WidgetLoadingGuard>
        </RunSearchEffect>
      </TopicInfosEmptyGuard>
      <InsightModal
        open={isModalOpen}
        onClose={onClose}
        selectedInsights={selectedInsights}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        detailSetting={detailSetting}
        widgetSettingWithSelection={widgetSettingWithSelection}
      />
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebTopicComparisonWidget
